export const FETCH_COMPANY_REQUEST_APPROVALS =
  "FETCH_COMPANY_REQUEST_APPROVALS";
export const EDIT_COMPANY_REQUEST_APPROVAL = "EDIT_COMPANY_REQUEST_APPROVAL";
